//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/Expression.js";
import "../GeometricUtilities/GeometricUtilities.DepthSkewBuilder.js";
import "../no/SelectNXObject.js";
import "../GeometricUtilities/GeometricUtilities.Continuity.js";
import "../GeometricUtilities/GeometricUtilities.DegreesAndSegmentsOrPatchesBuilder.js";
import "../GeometricUtilities/GeometricUtilities.ControlPoleManagerData.js";
import "../no/Expression.js";
import "../no/GeometricUtilities.js";
import "../no/SelectObject.js";
let d=[[[1,"Blend",0,"Expression",0],[0,"CanBlend",1,0],[0,"CanCreateNewBody",1,0],[1,"DepthSkew",0,"GeometricUtilities.DepthSkewBuilder",0],[0,"IsEditPolesEnabled",1,0],[0,"IsEndLocked",1,0],[0,"IsG0",1,0],[0,"IsG1",1,0],[0,"IsG2",1,0],[0,"IsG3",1,0],[0,"IsStartLocked",1,0],[0,"MovementDirection",1,0],[0,"MovementMethod",1,0],[1,"ObjectToEdit",0,"SelectNXObject",0],[1,"Offset",0,"Expression",0],[1,"OppositeEdgeContinuity",0,"GeometricUtilities.Continuity",0],[1,"Parameterization",0,"GeometricUtilities.DegreesAndSegmentsOrPatchesBuilder",0],[1,"PoleManager",0,"GeometricUtilities.ControlPoleManagerData",0],[0,"SymmetryPlane",1,"Plane",0],[0,"SymmetryPlaneOption",1,0]],[[[],"ResetPoleEditing",{},0,0],[[],"UpdateSurfacePostPoleEditing",{},0,0]],[]];
SPLM.Features.EdgeSymmetryBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.EdgeSymmetryBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.EdgeSymmetryBuilder.SymmetryPlaneOptions = Object.freeze({
    "YZ" : "YZ", "XZ" : "XZ", "XY" : "XY", "Arbitrary" : "Arbitrary"});

SPLM.Features.EdgeSymmetryBuilder.MovementMethods = Object.freeze({
    "Normal" : "Normal", "Project" : "Project", "WCS" : "WCS"});

SPLM.Features.EdgeSymmetryBuilder.MovementDirections = Object.freeze({
    "X" : "X", "Y" : "Y", "Z" : "Z"});

export default SPLM;